var SearchTermSortScore;
(function (SearchTermSortScore) {
    SearchTermSortScore[SearchTermSortScore["ExactMatch"] = 0] = "ExactMatch";
    SearchTermSortScore[SearchTermSortScore["StartsWith"] = 1] = "StartsWith";
    SearchTermSortScore[SearchTermSortScore["Includes"] = 2] = "Includes";
})(SearchTermSortScore || (SearchTermSortScore = {}));
export const AddOn_SearchTerm = {
    key: 'searchTerm',
    methodName: 'getSearchTerm',
    resultFilter: (value, result) => {
        const itemValue = result.filterResults[AddOn_SearchTerm.key].value;
        if (itemValue === value)
            return { pass: true, score: SearchTermSortScore.ExactMatch };
        if (itemValue.startsWith(value))
            return { pass: true, score: SearchTermSortScore.StartsWith };
        if (itemValue.includes(value))
            return { pass: true, score: SearchTermSortScore.Includes };
        return { pass: false };
    },
    isActive: (param) => !!param && param.length >= 3,
};
//# sourceMappingURL=types.js.map